/**
 * legalContents.js
 * 역할: 랜딩 페이지 푸터의 법적 정보 모달 콘텐츠 정의
 *       - 서비스 이용약관 / 개인정보처리방침 / 이메일 무단수집 거부
 *       - 정식 게시 전 임시 초안. 법무 검토 후 교체 예정.
 */

const COMPANY = 'DRONE INSPECT'
const EFFECTIVE_DATE = '2026-05-06'

// 베타 임시본 안내 — terms / privacy 에만 노출. 정식 법무 검토 완료 시 false 로 토글하면 배너 자동 제거
export const BETA_NOTICE_ENABLED = true

export const LEGAL_CONTENTS = {
  terms: {
    key: 'terms',
    title: '서비스 이용약관',
    effectiveDate: EFFECTIVE_DATE,
    isBeta: true,
    sections: [
      {
        heading: '제1조 (목적)',
        body: `이 약관은 ${COMPANY}(이하 "회사")가 제공하는 드론 자율비행 기반 정밀 하자점검 서비스(이하 "서비스")의 이용 조건 및 절차, 회사와 이용자 간의 권리·의무 및 기타 필요한 사항을 규정함을 목적으로 합니다.`,
      },
      {
        heading: '제2조 (정의)',
        body: `1. "서비스"란 회사가 제공하는 드론 자율비행 스캔, AI 비전 기반 하자 식별, 3D 디지털 트윈 생성, 리포트 발행 및 관련 부가 기능 일체를 말합니다.
2. "이용자"란 본 약관에 따라 회사와 이용계약을 체결하고 서비스를 이용하는 회원 및 비회원을 말합니다.
3. "회원"이란 회사와 서비스 이용계약을 체결하고 회사가 부여한 ID를 통해 서비스를 이용하는 자를 말합니다.
4. "콘텐츠"란 회사가 서비스 제공 과정에서 생성하는 3D 모델, 하자 리포트, 분석 데이터를 말합니다.`,
      },
      {
        heading: '제3조 (약관의 효력 및 변경)',
        body: `1. 본 약관은 서비스 화면에 게시하거나 기타 방법으로 공지함으로써 효력이 발생합니다.
2. 회사는 관계 법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있으며, 개정 시 적용일자 및 개정 사유를 명시하여 적용일자 7일 전부터 공지합니다.
3. 이용자가 변경된 약관에 동의하지 않는 경우 이용계약을 해지할 수 있습니다.`,
      },
      {
        heading: '제4조 (서비스의 제공 및 변경)',
        body: `1. 회사는 다음과 같은 업무를 제공합니다.
   가. 드론 자율비행 기반 현장 스캔
   나. AI 비전 알고리즘을 통한 하자 자동 식별
   다. 3D 디지털 트윈 모델 생성 및 좌표 매핑
   라. 하자 리포트 발행 및 보수 가이드 제공
   마. 기타 회사가 정하는 업무
2. 회사는 서비스의 내용·운영상·기술상의 사항을 변경할 수 있으며, 사전에 공지합니다.`,
      },
      {
        heading: '제5조 (이용자의 의무)',
        body: `이용자는 다음 행위를 하여서는 안 됩니다.
1. 신청 또는 변경 시 허위 내용 등록
2. 회사의 서비스를 이용한 부정 영리 행위
3. 다른 이용자의 ID를 부정 사용하는 행위
4. 회사가 게시한 정보의 변경
5. 외설·폭력적 메시지 등 공서양속에 반하는 정보 전송
6. 회사 및 기타 제3자의 저작권 등 지식재산권 침해
7. 기타 관계 법령에 위배되는 행위`,
      },
      {
        heading: '제6조 (계약 해지 및 이용 제한)',
        body: `1. 이용자는 언제든지 서비스 이용을 중단하고 회원 탈퇴를 신청할 수 있습니다.
2. 회사는 이용자가 본 약관을 위반하거나 서비스의 정상적 운영을 방해한 경우 사전 통지 없이 이용계약을 해지하거나 서비스 이용을 제한할 수 있습니다.`,
      },
      {
        heading: '제7조 (책임 제한)',
        body: `1. 회사는 천재지변, 전쟁 및 기타 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 책임이 면제됩니다.
2. 회사는 이용자의 귀책사유로 인한 서비스 이용의 장애에 대하여 책임을 지지 않습니다.
3. 회사가 제공하는 하자 리포트는 참고 자료이며, 최종 보수 결정은 이용자의 책임 하에 이루어집니다.`,
      },
      {
        heading: '제8조 (분쟁 해결)',
        body: `1. 회사와 이용자 간 발생한 분쟁은 상호 협의하여 해결함을 원칙으로 합니다.
2. 협의가 이루어지지 않을 경우 「민사소송법」상의 관할법원에 소를 제기할 수 있습니다.`,
      },
      {
        heading: '부칙',
        body: `본 약관은 ${EFFECTIVE_DATE}부터 시행합니다.

※ 본 약관은 정식 게시 전 임시 초안입니다. 법무 검토 후 정식 약관으로 교체될 예정입니다.`,
      },
    ],
  },

  privacy: {
    key: 'privacy',
    title: '개인정보처리방침',
    effectiveDate: EFFECTIVE_DATE,
    isBeta: true,
    sections: [
      {
        heading: '개인정보처리방침 개요',
        body: `${COMPANY}(이하 "회사")는 「개인정보 보호법」 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다.`,
      },
      {
        heading: '제1조 (개인정보의 처리 목적)',
        body: `회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.

1. 회원 가입 및 관리: 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리
2. 서비스 제공: 드론 자율비행 점검 서비스, 3D 디지털 트윈 생성, 하자 리포트 발행
3. 고충 처리: 민원인의 신원 확인, 민원사항 확인, 사실조사를 위한 연락·통지
4. 마케팅 및 광고에의 활용 (별도 동의 시): 신규 서비스 개발 및 맞춤 서비스 제공`,
      },
      {
        heading: '제2조 (수집하는 개인정보 항목)',
        body: `1. 회원가입 시 (필수)
   - 개인 회원: 이메일, 비밀번호, 성함, 휴대전화번호
   - 사업자 회원: 위 항목 + 사업자등록번호, 회사명, 대표자명

2. 서비스 이용 시 자동 수집
   - 접속 IP, 접속 일시, 서비스 이용 기록, 쿠키, 브라우저 정보

3. OAuth 로그인 시 (Google/Kakao/Naver)
   - 해당 플랫폼이 제공하는 이메일, 프로필 이름

4. 결제 시 (해당하는 경우)
   - 결제 수단 정보(카드사명, 카드번호 일부 등 — 결제대행사가 보관)`,
      },
      {
        heading: '제3조 (개인정보의 보유 및 이용기간)',
        body: `1. 회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 보유·이용기간 내에서 개인정보를 처리·보유합니다.
2. 회원 탈퇴 시 즉시 파기를 원칙으로 하나, 다음의 경우 관계 법령에 따라 일정 기간 보관합니다.
   - 계약 또는 청약철회 등에 관한 기록: 5년 (전자상거래법)
   - 대금결제 및 재화 등의 공급에 관한 기록: 5년 (전자상거래법)
   - 소비자의 불만 또는 분쟁처리에 관한 기록: 3년 (전자상거래법)
   - 로그인 기록: 3개월 (통신비밀보호법)`,
      },
      {
        heading: '제4조 (개인정보의 제3자 제공)',
        body: `회사는 정보주체의 개인정보를 제1조에서 명시한 목적 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 「개인정보 보호법」 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.`,
      },
      {
        heading: '제5조 (정보주체의 권리·의무 및 행사방법)',
        body: `정보주체는 회사에 대해 언제든지 다음의 개인정보 보호 관련 권리를 행사할 수 있습니다.
1. 개인정보 열람 요구
2. 오류 등이 있을 경우 정정 요구
3. 삭제 요구
4. 처리 정지 요구

권리 행사는 회사에 대해 서면, 전자우편 등을 통하여 하실 수 있으며, 회사는 이에 대해 지체 없이 조치하겠습니다.`,
      },
      {
        heading: '제6조 (개인정보의 안전성 확보 조치)',
        body: `회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.
1. 관리적 조치: 내부관리계획 수립·시행, 정기적 직원 교육
2. 기술적 조치: 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 고유식별정보 등의 암호화, 보안프로그램 설치
3. 물리적 조치: 전산실, 자료보관실 등의 접근통제`,
      },
      {
        heading: '제7조 (개인정보 보호책임자)',
        body: `회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.

▶ 개인정보 보호책임자
  - 성명: (책임자 지정 후 기재)
  - 연락처: 02-2038-0800
  - 이메일: droneinspect.noreply@gmail.com`,
      },
      {
        heading: '제8조 (개인정보처리방침 변경)',
        body: `이 개인정보처리방침은 ${EFFECTIVE_DATE}부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.

※ 본 처리방침은 정식 게시 전 임시 초안입니다. 법무 검토 후 정식 처리방침으로 교체될 예정입니다.`,
      },
    ],
  },

  noEmail: {
    key: 'noEmail',
    title: '이메일 무단수집 거부',
    effectiveDate: EFFECTIVE_DATE,
    isBeta: false,
    sections: [
      {
        heading: '이메일 무단수집 거부',
        body: `본 웹사이트에 게시된 이메일 주소가 전자우편 수집 프로그램이나 그 밖의 기술적 장치를 이용하여 무단으로 수집되는 것을 거부하며, 이를 위반 시 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」에 의해 형사 처벌됨을 유념하시기 바랍니다.`,
      },
      {
        heading: '관련 법령',
        body: `「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 제50조의2 (전자우편주소의 무단 수집행위 등 금지)

① 누구든지 인터넷 홈페이지 운영자 또는 관리자의 사전 동의 없이 인터넷 홈페이지에서 자동으로 전자우편주소를 수집하는 프로그램이나 그 밖의 기술적 장치를 이용하여 전자우편주소를 수집하여서는 아니 된다.

② 누구든지 제1항을 위반하여 수집된 전자우편주소를 판매·유통하여서는 아니 된다.

③ 누구든지 제1항 및 제2항에 따라 수집·판매 및 유통이 금지된 전자우편주소임을 알고 이를 정보 전송에 이용하여서는 아니 된다.

위반 시 1천만원 이하의 벌금에 처해질 수 있습니다.`,
      },
      {
        heading: '게시일',
        body: EFFECTIVE_DATE,
      },
    ],
  },
}
